/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvailableInsuredDto } from './AvailableInsuredDto';
import {
    AvailableInsuredDtoFromJSON,
    AvailableInsuredDtoFromJSONTyped,
    AvailableInsuredDtoToJSON,
    AvailableInsuredDtoToJSONTyped,
} from './AvailableInsuredDto';

/**
 * Response for group insured selection (MNCAP limits to 2 insureds max)
 * @export
 * @interface GetGroupSelectionResponse
 */
export interface GetGroupSelectionResponse {
    /**
     * List of other available insureds with their group price simulation
     * @type {Array<AvailableInsuredDto>}
     * @memberof GetGroupSelectionResponse
     */
    availableInsureds: Array<AvailableInsuredDto>;
}

/**
 * Check if a given object implements the GetGroupSelectionResponse interface.
 */
export function instanceOfGetGroupSelectionResponse(value: object): value is GetGroupSelectionResponse {
    if (!('availableInsureds' in value) || value['availableInsureds'] === undefined) return false;
    return true;
}

export function GetGroupSelectionResponseFromJSON(json: any): GetGroupSelectionResponse {
    return GetGroupSelectionResponseFromJSONTyped(json, false);
}

export function GetGroupSelectionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroupSelectionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'availableInsureds': ((json['availableInsureds'] as Array<any>).map(AvailableInsuredDtoFromJSON)),
    };
}

export function GetGroupSelectionResponseToJSON(json: any): GetGroupSelectionResponse {
    return GetGroupSelectionResponseToJSONTyped(json, false);
}

export function GetGroupSelectionResponseToJSONTyped(value?: GetGroupSelectionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'availableInsureds': ((value['availableInsureds'] as Array<any>).map(AvailableInsuredDtoToJSON)),
    };
}

